import Quill from "quill";

/**
 * Keeps H1 out of the edited content: the page title is the only H1 on the
 * public pages, a heading inside the text is at most H2.
 *
 * The toolbar does not offer H1, but Quill still knows the format, so a pasted
 * <h1> or one in already stored content would come through. This clipboard
 * matcher turns them into H2. It has to be in the clipboard config, not added
 * later, because Quill converts the initial content in its constructor.
 */
export const noH1Matcher = [
  "H1",
  (node, delta) => {
    const Delta = Quill.import("delta");
    return new Delta(
      delta.ops.map((op) =>
        op.attributes?.header === 1
          ? { ...op, attributes: { ...op.attributes, header: 2 } }
          : op
      )
    );
  },
];
